<template>
    <div id="logincontent" :style="loginimg" >
      <el-form ref="loginForm" :model="form" :rules="rules" label-width="0px" class="login-box">
        <h3 class="login-title">欢迎登录</h3>
        <el-form-item label="" prop="username">
          <el-input type="text" placeholder="请输入账号" v-model="form.username" prefix-icon="el-icon-user" />
           
        </el-form-item>
        <el-form-item label="" prop="password">
          <el-input type="password" placeholder="请输入密码" v-model="form.password" prefix-icon="el-icon-lock"/> 
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit('loginForm')" class="loginsubmit">登录</el-button>
        </el-form-item>
        <el-form-item>
            <router-link to="/register" class="link">注册账号</router-link>
        </el-form-item>
      </el-form>
    </div>
  </template>
  
  <script>
    import storage from '../../Storage/storage.js';
    export default {
      name: "Login",
      data() {
        return {
          form: {
            username: '',
            password: ''
          },

          loginimg:{
            backgroundImage: "url(./static/images/loginbackground.jpg)",
            backgroundSize:'100% 100%',
            width:'100%',
            height:'100%',
            backgroundRepeat:'no-repeat',
            position:'absolute',
            left:'0',
            top:'0'
          },
  
          // 表单验证，需要在 el-form-item 元素中增加 prop 属性
          rules: {
            username: [
              {required: true, message: '账号不可为空', trigger: 'blur'}
            ],
            password: [
              {required: true, message: '密码不可为空', trigger: 'blur'}
            ]
          },
        }
      },
      methods: {
        onSubmit(formName) {
          // 为表单绑定验证功能
          this.$refs[formName].validate((valid) => {
            if (valid) {
              var Login=this.GLOBAL.Login;
                this.$http.post(Login,{username:this.form.username,password:this.form.password},{'headers': {'Content-Type': 'application/json'}},{emulateJSON:true}).then(function(res){
                      // console.log(res); 

                       
                      if(res.body.status){
                        storage.set('token',res.body.token);
                        storage.set('userid',res.body.user.id);
                        storage.set('username',res.body.user.username);

                        this.$router.push({
                              path: 'main',
                              query: {
                              }
                        }) 

                      }
                      else{
                        this.$message({
                          message: res.body.message,
                          type: 'success'
                        });  
                      }
                                         
                },function(err){})
            } else {
              return false;
            }
          });
        }
      }
    }
  </script>
  
  <style  scoped>
    .login-box {
      border: 1px solid #DCDFE6;
      width: 300px;
      margin: 260px auto;
      padding: 35px 35px 15px 35px;
      border-radius: 5px;
      -webkit-border-radius: 5px;
      -moz-border-radius: 5px;
      box-shadow: 0 0 25px #909399;
      background: #ffffff;
    }
  
    .login-title {
      text-align: center;
      margin: 0 auto 40px auto;
      color: #303133;
    }
    .loginsubmit{
        width: 100%;
    }
    .link{
        color: #409eff;
        text-decoration: none;
    }
  </style>
  


// WEBPACK FOOTER //
// src/components/LOGINREGISTER/login.vue